import { render, staticRenderFns } from "./chargeDetail.vue?vue&type=template&id=13ecdcc0&scoped=true&"
import script from "./chargeDetail.vue?vue&type=script&lang=js&"
export * from "./chargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./chargeDetail.vue?vue&type=style&index=0&id=13ecdcc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ecdcc0",
  null
  
)

export default component.exports